import { getStylesObjFromCss } from "../../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    wrapper: {
      display: "flex !important",
      alignItems: "center",
      cursor: "pointer",
    },
    emojiAnchor: {
      fontSize: "20px !important",
      color: "#B9B9B9 !important",
    },
  },
  componentName: "EmojiSelector",
});
